<div [ngClass]="styleClass()">
    <iframe style="aspect-ratio: 16/9; width: 100% !important" [src]="embedUrl()" title="YouTube video player" frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen></iframe>
  </div>
  